module.exports = __webpack_public_path__ + "media/images/calendar-dc9eba97.svg";